import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { api } from '../../utils/api';
import Header from '../shared/Header';
import Footer from '../shared/Footer';
import SEO from '../shared/SEO';

const FAQPage = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.getFAQ().then(res => setFaqs(res.data)).catch(console.error);
  }, []);

  return (
    <div className="min-h-screen bg-[#FCFBF9]">
      <SEO
        title="FAQ"
        description="Frequently asked questions about Crowns by Preshy — booking, payment, hair preparation, rescheduling, and our policies."
        path="/faq"
      />
      <Header />

      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h1 className="font-serif text-4xl lg:text-5xl text-[#3E2723] mb-4 tracking-tight">Frequently Asked Questions</h1>
            <p className="text-[#786E66] text-lg">Everything you need to know before booking</p>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-[#E6DCD3] p-8"
            data-testid="faq-container"
          >
            {faqs.length > 0 ? (
              <Accordion type="single" collapsible className="space-y-4">
                {faqs.map((faq, idx) => (
                  <AccordionItem key={faq.id} value={faq.id} className="border-b border-[#E6DCD3] last:border-0" data-testid={`faq-item-${idx}`}>
                    <AccordionTrigger className="text-left font-serif text-lg text-[#3E2723] hover:text-[#2A1A17] py-4">
                      {faq.question}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#786E66] leading-relaxed pb-4">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            ) : (
              <p className="text-center text-[#786E66]">No FAQs available at the moment.</p>
            )}
          </motion.div>

          <div className="mt-12 text-center">
            <p className="text-[#786E66] mb-4">Still have questions?</p>
            <a 
              href="/contact"
              className="bg-[#3E2723] text-white hover:bg-[#2A1A17] rounded-full px-8 py-3 inline-flex items-center gap-2 transition-all hover:-translate-y-0.5"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQPage;
